module.exports = __webpack_public_path__ + "static/media/c565d025-f042-4dcd-be78-fae40bc26d01.839c5b44.jpeg";